import React from 'react';
import styles from './ModalWrapper.css';

export const ModalWrapper = ({ children }) => (
  <div data-test-id="modal-wrapper" className={styles.modalWrapper}>
    <div data-test-id="modal-content" className={styles.modalContent}>
      {children}
    </div>
  </div>
);